import styled from 'styled-components';

export const Container = styled.div`
  padding: 40px 0;

  .MuiSkeleton-root {
    border-radius: 8px;
  }
`;

export default Container;
